import {useCallback} from 'react';
import {IProductShort} from 'modules/products/types';
import {
    EventAction,
    EventCategory,
    EventCurrencyCodes,
    EventLabel,
    EventNames,
} from 'modules/google-analytics/constants';
import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';
import {getProductEcommerceData} from 'modules/product-card/analytics/gtag/helpers';
import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';
import {buildProductStoreEventContext} from 'modules/analytics/helpers/buildProductStoreEventContext';

export const useProductsPLPViewGtag = () => {
    const {eventLocation} = useGtagEventLocation();

    return useCallback(
        (products: (IProductShort & {position?: number})[]) => {
            const safeProducts = products || [];
            const dataLayerProducts = safeProducts.map((product) => {
                const productData = {...product} as any;

                return {
                    ...getProductEcommerceData(productData),
                    list: eventLocation,
                };
            });

            const dataLayerList = {
                ecommerce: {
                    currencyCode: EventCurrencyCodes.RUB,
                    impressions: dataLayerProducts,
                },
                event: EventNames.OWOX,
                eventAction: EventAction.Show,
                eventCategory: EventCategory.NonInteractions,
                eventLabel: EventLabel.Products,
                eventLocation,
                // Позиционно для каждого товара в батче, см. «Разметка. PLP. Сниппет».
                eventContext: safeProducts.map((product) =>
                    buildProductStoreEventContext({
                        isOnlyInStores: !product.canBuy && product.canReserve,
                        storesWithStockCount: product.storesWithStock?.length || 0,
                    }),
                ),
            };
            sendGtagEvent(dataLayerList);
        },
        [eventLocation],
    );
};
